export const routes = [
  {
    path: '/sala-principal/:id/sala-indicadores-leitura',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'sala.indicadores.leitura.list',
    meta: {
      requiresAuth: true
    }
  }
]
